<div
  #tutorialFormModal
  class="fade modal-lg modal"
  id="tutorialFormModal"
  tabindex="-1"
  aria-labelledby="tutorialFormModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="tutorialFormModalLabel">
          Creación de un tutorial
        </h1>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
          (click)="clearAllFields()"
        ></button>
      </div>

      <div class="modal-body">
        <span class="mt-3">Alcance del tutorial</span>
        <select
          class="form-select mb-3"
          [formControl]="allowedUserTypeFormControl"
        >
          <option [value]="null" selected>Elige alcance del tutorial</option>
          <option value="USER">App de usuarios</option>
          <option value="TABLET">Tablet en Gym</option>
          <option value="USER_TABLET">Tablet y App</option>
        </select>

        <div class="col-12">
          <label for="tutorialVideo" class="btn-custom-outline w-100"
            >Seleccionar Video</label
          >
          <input
            id="tutorialVideo"
            style="visibility: hidden"
            type="file"
            accept="video/mp4, video/mpeg"
            (change)="onVideoSelected($event)"
          />
          <span *ngIf="videoSelected">
            Imagen seleccionada: {{ tutorialVideo.name }}</span
          >
        </div>

        <button
          [disabled]="allowedUserTypeFormControl.invalid || !videoSelected"
          class="col-12 mt-2 btn-custom d-flex justify-content-center"
          (click)="createTutorial()"
        >
          <span *ngIf="!loading">Crear</span>
          <div
            *ngIf="loading"
            class="spinner-border d-flex justify-content-center"
            role="status"
          >
            <span class="visually-hidden">Loading...</span>
          </div>
        </button>
      </div>
    </div>
  </div>
</div>
